// A couple of blocks have a really annoying background layer that needs to fill the screen width
// however the elements themselves aren'T full-width... and not even centered most of the time
// After giving up on CSS, here's a JS fix

export default class FunkyBackgroundsControl
{
    constructor ()
    {

        this.bgs    = document.querySelectorAll( '.full-width-bg' );
        this.bgsArr = Array.from( this.bgs );

        // console.log( '[FunkyBackgroundsControl] Let us funk!', this.bgs );

        // no BGs, no cry
        if ( !this.bgs || this.bgs.length < 1 )
        {
            return;
        }

        // I only want to do this (fade it in once positioned) on initial layout
        this.positionedClassAdded = false;

        this.bindEvents();
    }


    bindEvents ()
    {
        this.resizeObserver = new ResizeObserver( entries =>
        {
            for ( let entry of entries )
            {
                this.repositionBg( entry.target );
            }
        } );

        this.bgsArr.forEach( bg =>
        {
            this.resizeObserver.observe( bg );
        } );
    }


    repositionBg ( bg )
    {
        bg.style.left = 0;

        const viewportOffset = bg.getBoundingClientRect();
        // const top = viewportOffset.top;
        const left           = viewportOffset.left;

        bg.style.left = left * -1 + 'px';


        if ( !this.positionedClassAdded )
        {
            bg.classList.add( 'positioned' );
        }
    }

}
